import React, {memo, useCallback, useEffect, useState} from "react"
import {useFormik} from "formik"
import {Button, Input} from "antd"
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons"
import * as yup from "yup"
import {OptionType} from "../../../types/types"

type PropsTypes = {
    setOptions: (options: Array<OptionType>) => void
    attributes: string | null
    setSubmitOptionsCallback: any
}
export const JsonRulesRadioOptions: React.FC<PropsTypes> = memo(({setOptions, attributes, setSubmitOptionsCallback}) => {
    const [schema, setSchema] = useState(yup.object().shape({
        option_1: yup.string().required('Введите название'),
    }))

    useEffect(() => {
        return () => {
            setSubmitOptionsCallback(null)
        }
    }, [])

    const formik = useFormik({
        initialValues: {
            option_1: '',
        } as any,
        validationSchema: schema,
        validateOnMount: true,
        onSubmit: () => {
        },
    })
    const {values, handleChange, handleBlur, errors, touched, setFieldValue, setValues, validateForm, setFieldTouched} = formik

    useEffect(() => {
        setSubmitOptionsCallback(() => async () => {
            if (Object.keys(values).length === 0 && values.constructor === Object) return false
            const formValid = await validateForm(values)
            return Object.keys(formValid).length === 0 && formValid.constructor === Object
        })
    }, [values])

    useEffect(() => {
        const opts: Array<OptionType> = []
        const schemas: any = {}
        const touched: any = {}

        for (const key in values) {
            opts.push({value: key, label: values[key]})
            schemas[key] = yup.string().required('Введите название')
            touched[key] = true
            if (values[key] === undefined) delete values[key]
        }

        setSchema(yup.object().shape(schemas))
        setOptions(opts)
    }, [values])

    useEffect(() => {
        if (attributes) {
            const parsed: Array<OptionType> = JSON.parse(attributes)
            const options: any = {}

            if (Array.isArray(parsed)) {
                parsed?.forEach((option) => {
                    options[option.value] = option.label
                })
            }

            if (Object.keys(options).length > 0 && options.constructor === Object) setValues(options)
        }
    }, [attributes])

    const fieldsMap = useCallback(() => {
        const map: any = []
        let parsed: Array<any> = []

        if (attributes) {
            const array = JSON.parse(attributes)
            if (Array.isArray(array)) parsed = array
        }

        for (const key in values) {
            if (key.includes('option_')) {
                const option = parseInt(key.replace('option_', ''), 10)
                if (option) {
                    const isInvalid = errors[`option_${option}`]

                    let find = false

                    for (const i of parsed) {
                        if (i.value === `option_${option}`) {
                            find = true
                            break
                        }
                    }

                    map.push((
                        <div key={option} style={{marginBottom: 10}}>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <Input value={values[`option_${option}`]}
                                       name={`option_${option}`}
                                       onBlur={handleBlur}
                                       onChange={handleChange}
                                       allowClear
                                       status={isInvalid ? 'error' : ''}
                                       addonBefore="Опция"
                                />
                                {
                                    !find
                                        ? <MinusCircleOutlined style={{marginLeft: 5}}
                                                               onClick={() => setFieldValue(`option_${option}`, undefined)}
                                        />
                                        : null
                                }

                            </div>
                        </div>
                    ))
                }
            }
        }

        return map
    }, [values, errors, touched, attributes])

    return (
        <div>
            {fieldsMap()}
            <div style={{marginBottom: 15, marginTop: 10, textAlign: 'center'}}>
                {Object.keys(values).length === 0 && values.constructor === Object ? <div className="input-error-visible">Добавьте опции</div> : null}
                <Button type="dashed"
                        onClick={() => {
                            const options: Array<number> = []

                            for (const key in values) {
                                if (key.includes('option_') && values[key]) {
                                    const option = parseInt(key.replace('option_', ''), 10)
                                    if (option) options.push(option)
                                }
                            }

                            let max = Math.max(...options)
                            max = max > 0 ? max : 0
                            setFieldValue(`option_${max + 1}`, '')
                        }}
                        icon={<PlusOutlined/>}
                >
                    Добавить опцию
                </Button>
            </div>
        </div>
    )
})